import React from 'react';
import { motion } from 'framer-motion';
import { MailIcon } from 'lucide-react';
export function ContactSection() {
  const profiles = [{
    name: 'Lola Mourot',
    title: 'Co-Founder',
    subtitle: 'Wine · Partnership Inquiries · Marketing',
    nationality: '🇫🇷 French & 🇺🇸 American',
    languages: 'French, English, Spanish',
    image: 'https://cdn.magicpatterns.com/uploads/buidikLX5j69D3XLLzqehQ/lola_mourot_profile_pic.jpg',
    email: 'lola@wineanddesign.com'
  }, {
    name: 'Solal Hamou',
    title: 'Co-Founder',
    subtitle: 'Client Relations · Legislation · Corporate',
    nationality: '🇫🇷 French',
    languages: 'French, English',
    image: 'https://cdn.magicpatterns.com/uploads/aUf29wtCCvh8sqEPRbxrQm/Solal_Hamour_profile_picture.png',
    email: 'solal@wineanddesign.com'
  }];
  return <section id="contact" className="py-24 bg-cream-50 border-t border-cream-200" data-id="element-36">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-37">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-38">
          <span className="text-wine font-semibold tracking-wider uppercase text-sm mb-4 block" data-id="element-39">
            Contact Us
          </span>
          <h2 className="font-playfair text-4xl md:text-5xl text-charcoal font-bold mb-6" data-id="element-40">
            Get In <span className="italic text-wine font-normal" data-id="element-41">Touch</span>
          </h2>
          <p className="text-lg text-brown/70" data-id="element-42">
            Have a question about our custom labels or want to discuss a large
            order? We'd love to hear from you.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-4xl mx-auto" data-id="element-43">
          {profiles.map((profile, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-white p-8 rounded-sm shadow-subtle border border-cream-200 flex flex-col items-center text-center hover:shadow-elevated transition-shadow duration-300" data-id="element-44">
              <div className="w-32 h-32 rounded-full overflow-hidden mb-6 border-4 border-cream-100 shadow-sm flex items-center justify-center bg-gray-200 text-wine font-playfair text-3xl font-bold" data-id="element-45">
                {profile.image ? <img src={profile.image} alt={profile.name} className={`w-full h-full object-cover ${profile.name === 'Solal Hamou' ? 'scale-[1.6]' : ''}`} data-id="element-46" /> : profile.initials}
              </div>
              <h3 className="font-playfair text-2xl font-bold text-charcoal mb-1" data-id="element-47">
                {profile.name}
              </h3>
              <p className="text-wine font-medium text-sm uppercase tracking-wider mb-1" data-id="element-48">
                {profile.title}
              </p>
              {profile.subtitle && <p className="text-brown/60 text-xs mb-3" data-id="element-49">{profile.subtitle}</p>}
              <div className="text-xs text-brown/50 mb-1" data-id="element-50">
                Nationality: {profile.nationality}
              </div>
              <div className="text-xs text-brown/50 mb-6" data-id="element-51">
                Languages: {profile.languages}
              </div>
              <a href={`mailto:${profile.email}`} className="inline-flex items-center text-brown/70 hover:text-wine transition-colors" data-id="element-52">
                <MailIcon className="w-4 h-4 mr-2" data-id="element-53" />
                {profile.email}
              </a>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="mt-16 text-center" data-id="element-54">
          <p className="text-brown/70 mb-6" data-id="element-55">For general inquiries:</p>
          <a href="mailto:hello@wineanddesign.com" className="inline-flex items-center justify-center px-8 py-4 bg-wine text-white rounded-sm font-medium hover:bg-wine-700 transition-colors duration-300 shadow-md" data-id="element-56">
            hello@wineanddesign.com
          </a>
        </motion.div>
      </div>
    </section>;
}